// The signed-in user as this origin has it STORED, for readers that run outside
// a Pinia context — the deep-link builders in module-links.ts, which several
// specs load with Pinia mocked away. Decoded from the stored token exactly as
// stores/auth.ts does it; the store imports this rather than the other way
// round, so importing a util never drags a store definition in.
export interface JwtPayload {
  userId: string;
  // Absent for a phone-only account (issue 698, ADR 0093).
  email?: string;
  isSystemAdmin?: boolean;
  exp?: number;
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    return JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function storedUserId(): string | null {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? decodeJwt(token)?.userId ?? null : null;
}
